/*eslint-disable*/
import React from "react";
// react plugin for creating notifications over the dashboard
import NotificationAlert from "react-notification-alert";
import axios from "axios";
import firebase from "firebase.config";

class Notifications extends React.Component {
  state = {
    title: "",
    info: ""
  };

  // ----- Tailwind 공통 입력 스타일 -----
  inputCls =
    "w-full rounded-lg border border-gray-300 bg-white px-3 py-2 text-sm text-gray-800 placeholder-gray-400 shadow-sm outline-none transition focus:border-sky-500 focus:ring-2 focus:ring-sky-200";

  handleChange = (event, key) => {
    this.setState({
      [key]: event.target.value
    });
  };

  sendNotification = () => {
    if (this.state.info.length <= 1 || this.state.title.length <= 1) {
      alert("Please enter valid details");
      return;
    }

    firebase
      .database()
      .ref(
        "/groupsData/" +
          this.props.userDetails.groupPath +
          "/notificationHistory"
      )
      .push({
        title: this.state.title,
        content: this.state.info,
        timestamp: new Date().getTime()
      });
    let data = {
      //app_id: "fe01d6b4-f76c-4124-8f09-7aeb7a63f442",
      app_id: "db411138-28fb-4061-b193-63fbfe5df32d",
      contents: { en: this.state.info },
      headings: { en: this.state.title },
      // "subtitle": { "en": "original.subtitle" },
      filters: [
        {
          field: "tag",
          key: "channel",
          relation: "=",
          value: this.props.userDetails.groupPath
        }
      ]
    };
    axios
      .post("https://onesignal.com/api/v1/notifications", data, {
        headers: {
          "Content-Type": "application/json; charset=utf-8",
          Authorization:
            "Basic NWUyZGJkYTQtMWQ2Ny00MTZkLTk0MGEtZjE2ZDA4MDcxZmNh" //"NzVjOTY1M2MtZDA0Zi00NTE5LTgzOWQtYWZkYmRhNWE4MmE4"
        }
      })
      .then(res => {
        this.setState({
          title: "",
          info: ""
        });
        alert("Notification sent successfully");
      })
      .catch(err => {
        alert(
          "There was an error sending notification, please try again later."
        );
      });
  };

  render() {
    return (
      <div className="content">
        <NotificationAlert ref={this.notificationAlert} />
        <div className="mx-auto w-full max-w-2xl px-2 pb-10">
          {/* 안내 배너 */}
          <div className="mb-6 rounded-2xl bg-gradient-to-r from-sky-500 to-cyan-400 p-6 text-white shadow-lg">
            <h2 className="mb-1 text-2xl font-bold">🔔 푸시 알림 보내기</h2>
            <p className="text-sm leading-relaxed text-sky-50">
              구독자들의 휴대폰으로 보낼 알림을 작성하세요. 제목과 내용을 입력한 뒤
              <span className="font-semibold"> [알림 보내기]</span> 버튼을 누르면
              바로 전송됩니다.
            </p>
          </div>

          <section className="rounded-2xl border border-gray-100 bg-white p-6 shadow-sm">
            <div className="mb-4 flex items-center gap-2">
              <span className="flex h-7 w-7 items-center justify-center rounded-full bg-sky-100 text-sm font-bold text-sky-600">
                ✎
              </span>
              <h3 className="text-lg font-bold text-gray-800">알림 내용</h3>
            </div>

            <div className="space-y-5">
              <div>
                <label className="mb-1 block text-xs font-semibold text-gray-600">
                  제목 <span className="text-rose-500">*</span>
                </label>
                <input
                  type="text"
                  placeholder="예) 이번 주 뉴스레터가 도착했어요!"
                  value={this.state.title}
                  className={this.inputCls}
                  onChange={event => this.handleChange(event, "title")}
                />
              </div>

              <div>
                <label className="mb-1 block text-xs font-semibold text-gray-600">
                  내용 <span className="text-rose-500">*</span>
                </label>
                <textarea
                  rows={4}
                  placeholder="예) 지금 앱을 열어 새 소식을 확인해 보세요."
                  value={this.state.info}
                  className={this.inputCls + " resize-y"}
                  onChange={event => this.handleChange(event, "info")}
                />
              </div>
            </div>

            <div className="mt-6 flex justify-end">
              <button
                type="button"
                className="inline-flex items-center gap-2 rounded-xl bg-sky-500 px-6 py-2.5 text-sm font-bold text-white shadow-md transition hover:bg-sky-600"
                onClick={() => this.sendNotification()}
              >
                📨 알림 보내기
              </button>
            </div>
          </section>
        </div>
      </div>
    );
  }
}

export default Notifications;
